import * as Flux from 'dg-web-shared/lib/Flux.tsx';
import { Container, TabItem, Tabs } from '../../ui/layout/TabContent.tsx';
import * as CurrentOperatorLoginState from '../../common/state/CurrentOperatorLoginState.ts';
import { UsbSticksBody } from './UsbSticksBody.tsx';
import { OperatorAppRoutes } from '../../app/config/OperatorRoutingConfig.tsx';
import { getNavigationText } from '../../layout/components/BreadCrumb.tsx';

export const UsbSticks: React.FC = () => {
    const { storeState } = Flux.useStore(state => ({
        allState: state,
        currentLogin: CurrentOperatorLoginState.get(state),
    }));
    const login = storeState.currentLogin.data;

    if (!login) {
        return null;
    }

    return (
        <Container>
            <Tabs>
                <TabItem
                    active={true}
                    description={getNavigationText(OperatorAppRoutes.UsbSticks)}
                    onClick={null}
                />
            </Tabs>
            <UsbSticksBody />
        </Container>
    );
};
